import { UseQueryResult, useQuery } from '@tanstack/react-query';

import { ComponentMetadataModel, ExpressionMetadataModel, UserInterfaceClient } from '../../../api/api';
import { useApiClient } from '@@common';

export interface UserInterfaceMetadata {
	components: ComponentMetadataModel[];
	expressions: ExpressionMetadataModel[];
}

export default function useApiUserInterfaceMetadata(): UseQueryResult<UserInterfaceMetadata, Error> {
	const client = useApiClient(UserInterfaceClient);
	return useQuery({
		queryKey: ['userInterfaceMetadata'],
		queryFn: async () => {
			const [components, expressions] = await Promise.all([client.getComponentMetadata(), client.getExpressionMetadata()]);
			return { components, expressions };
		},
	});
}
